const mutations = {
  setPPOBProducts(state, ppob_products) {
    state.ppob_products = ppob_products;
  },
  setPPOBProduct(state, ppob_product) {
    state.ppob_product = ppob_product
  },
};

export default mutations;